module.exports = __webpack_public_path__ + "static/landvernd-cropped-f2e47a730df95306afb374f1e3f43c40.png";